import _ from "@lodash";
import { AppBar, Avatar, Typography, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import connect from 'react-redux/es/connect/connect';

const styles = theme => ({
    navbarNovo: {
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#ccc" : "#666"
    },
    root: {
        '& .user': {
            '& .username, & .email': {
                transition: theme.transitions.create('opacity', {
                    duration: theme.transitions.duration.shortest,
                    easing: theme.transitions.easing.easeInOut
                })
            }
        }
    },
    avatar: {
        width: 72,
        height: 72,
        position: 'absolute',
        top: 60,
        padding: 8,
        background: theme.palette.background.default,
        boxSizing: 'content-box',
        left: '50%',
        transform: 'translateX(-50%)',
        '& > img': {
            borderRadius: '50%'
        }
    }
});

const UserNavbarHeader = ({ user, classes }) => {
    return (
        <AppBar
            position="static"
            color="primary"
            elevation={0}
            classes={{ root: classes.root }}
            className={classNames(classes.navbarNovo, "user relative flex flex-col items-center justify-center pt-24 pb-64 mb-32 z-0")}
        >
            <Typography className="username text-16 whitespace-no-wrap" color="inherit">{!_.isNull(user.data.nomesocial) ? user.data.nomesocial : user.data.nome}</Typography>
            <Avatar
                className={classNames(classes.avatar, "avatar")}
                alt="user photo"
                src={user.data.foto !== null && user.data.foto.length > 0 ? user.data.foto : "assets/images/avatars/profile.png"}
            />
        </AppBar>
    );
};

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(UserNavbarHeader));
